import axiosInstance from "../axios/axios_instance"
const http = axiosInstance("/protected",  null, "/dashboard")


const getReports = () => http.get("/reports");
const deleteReport = (report_id) => http.delete(`/reports/${report_id}`)
const downloadReport = (report_id) => http.post(`/reports/${report_id}`)
const getValidROITeams = () => http.get("/roi_teams");
const generateROIReport = (teams, reportID) => http.post("/roi_report", {
    "teams": teams,
    "report_id": reportID
})
const getROIData = (teams) => http.post("/roi_data", {
    "teams": teams
})
const getROIReports = () => http.get("/roi_report")
const downloadROIReport = (path) => http.post("/download_roi", {
    "path": path
})

const finaliseReport = (report_type, details, data, config, img_data) => http.post("/finalise_report", {
    "type": report_type,
    "details": details,
    "data": data,
    "config": config,
    "img": img_data
})

const getROIFilter = () => http.get("/roi_filter")
const saveROIFilter = (filter) => http.post("/roi_filter", {
    "filter": filter
})

const reportsBySurvey = (survey_id) => http.get(`/reports_by_survey/${survey_id}`)

export default {
    getReports,
    getValidROITeams,
    generateROIReport,
    getROIData,
    getROIReports,
    downloadROIReport,
    finaliseReport,
    getROIFilter,
    saveROIFilter,
    deleteReport,
    downloadReport,
    reportsBySurvey
}